import React, { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";

const SkillOverlayItem = ({ skill }) => {
  const text = typeof skill === "string" ? skill : skill.text;
  const details = typeof skill === "string" ? [] : skill.details;

  const overlayRef = useRef(null);

  const showOverlay = (event) => {
    overlayRef.current.toggle(event);
  };

  const hideOverlay = (event) => {
    overlayRef.current.hide();
  };

  return (
    <div>
      {details && details.length ? (
        <>
          <div
            className="skill-with-details cursor-pointer"
            onMouseEnter={showOverlay}
            onMouseLeave={hideOverlay}
          >
            {text}
          </div>
          <OverlayPanel ref={overlayRef}>
            <div className="custom-overlay-content11">
              <h3>
                <b>{text}</b>
              </h3>
              <ul>
                {details.map((skillInfo) => (
                  <li>{skillInfo}</li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        </>
      ) : (
        text
      )}
    </div>
  );
};

export default SkillOverlayItem;
